import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutService } from '../layout.service';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'admin-sidebar',
  templateUrl: './admin-sidebar.component.html',
  styleUrls: ['./admin-sidebar.component.scss']
})
export class AdminSidebarComponent {
  constructor(public layoutService: LayoutService) {}
}
